import { render, staticRenderFns } from "./Enfermeria.vue?vue&type=template&id=113e0c98&"
import script from "./Enfermeria.vue?vue&type=script&lang=js&"
export * from "./Enfermeria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports